import type { FacetOption } from '../types/Facet';

export const setMultiSelectActiveState = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    }

    return option;
  });
};

export const setSingleSelectActiveState = (
  facetOptions: FacetOption[],
  value: FacetOption['value'],
  active: boolean,
): FacetOption[] => {
  return facetOptions.map((option) => {
    if (option.value === value) {
      return {
        ...option,
        active,
      };
    } else if (active) {
      return {
        ...option,
        active: false,
      };
    }

    return option;
  });
};
